var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-success",class:_vm.size},[_c('div',{staticClass:"path1"}),_c('div',{staticClass:"path2"})])}
var staticRenderFns = []

export { render, staticRenderFns }